import React from 'react'

import './index.scss'

import Container from '../../../../components/Container'

const CompanyFeature = ({ image, imageSize, title, text, flexDirection }) => (
  <Container style={{ flexDirection }} className="company-feature">
    <div className="company-feature__image">
      <img style={{ width: `${imageSize}px`, height: `${imageSize}px` }} src={image} alt="Feature"></img>
    </div>
    <div className="company-feature__text">
      {title}
      {text}
    </div>
  </Container>
)

export default CompanyFeature
